import React from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Row, Col } from "reactstrap"

interface ReportItem {
  title: string
  iconClass: string
  total: string
  average: string
  badgecolor: string
  link?: string
}

const Miniwidget = (props: { reports: ReportItem[] }) => {
  return (
    <Row>
      {props.reports.map((report: ReportItem, key: number) => {
        const card = (
          <Card className="mini-stat bg-primary">
            <CardBody className="card-body mini-stat-img">
              <div className="mini-stat-icon">
                <i className={"float-end mdi mdi-" + report.iconClass}></i>
              </div>
              <div className="text-white">
                <h6 className="text-uppercase mb-3 font-size-16 text-white">{report.title}</h6>
                <h2 className="mb-4 text-white">{report.total}</h2>
                <span className={"badge bg-" + report.badgecolor}> {report.average} </span> <span className="ms-2">From previous period</span>
              </div>
            </CardBody>
          </Card>
        )
        return (
          <Col xl={3} sm={6} key={key}>
            {report.link ? <Link to={report.link} className="text-decoration-none d-block">{card}</Link> : card}
          </Col>
        )
      })}
    </Row>
  )
}

export default Miniwidget
